import React, { useEffect, useState } from "react";
import { fetchAccessToken } from "../backendServices";
import gails_logo from "./../gails_logo.svg";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:8000";

const Login = () => {
  const [code, setCode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codeParam = urlParams.get("code");

    if (codeParam) {
      setCode(true);
      fetchAccessToken(codeParam)
        .then((response) => {
          console.log(response);
          window.location.href = "/";
        })
        .catch((error) => {
          console.error(error);
        });
    }

    setIsLoading(false);
  }, []);

  const navigateToLogin = () => {
    if (BASE_URL === "http://localhost:8000") {
      window.location.href = BASE_URL + `/login`;
    } else {
      window.location.href = BASE_URL + `/api/login`;
    }
  };

  if (isLoading) {
    return null;
  }

  return (
    <div
      className="login-page"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}
    >
      {!code && (
        <div className="login-title-container">
          <img src={gails_logo} alt="GAILS logo" className="gails-logo" />
        </div>
      )}
      {!code && (
        <>
          <button className="submit-button" onClick={navigateToLogin}>
            Log In
          </button>
          <h6 className="login-page__warning">
            Please ensure you have logged into the correct bakery account
          </h6>
        </>
      )}
    </div>
  );
};

export default Login;
